import React from 'react'
import styled, { css } from 'styled-components'
import media from 'css-in-js-media'
import Container from './Container'
import { BodyCopy, H2 } from './Typography'
import Img from 'gatsby-image'
import { Row, Col } from 'react-styled-flexboxgrid'
import { StyledHeading } from './Heading'

const ContentInner = styled.div``
const Content = styled.div`
    ${media('>=desktop')} {
        max-width: 417px;
    }

    ${H2} {
        margin: 0 0 20px;
    }

    ${BodyCopy} {
        margin-bottom: 30px;
        ${media('<desktop')} {
            margin-bottom: 80px;
        }
    }
`

const CollageSection = styled.section`
    padding-top: 80px;
    padding-bottom: 40px;

    ${media('>=desktop')} {
        padding-top: 150px;
        padding-bottom: 150px;
    }

    ${({ layout }) => layout == '2' && Layout2}

    ${Col} {
        ${media('<desktop')} {
            width: 100%;
        }
    }

    ${({ layout }) =>
        layout != '2' &&
        css`
            & + ${StyledHeading} {
                ${media('<desktop')} {
                    padding-bottom: 80px;
                }
            }
        `}
`

const Layout2 = css`
    padding-top: 40px;
    padding-bottom: 40px;
    ${media('>=desktop')} {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .Image1 {
        ${media('<desktop')} {
            margin-top: 20px;
        }
    }

    .Image2 {
        ${media('>=desktop')} {
            position: absolute !important;
            width: 35%;
            bottom: 0;
            right: 74px;
        }
    }

    ${Content} {
        ${media('>=desktop')} {
            margin-left: 7.5vw;
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    }

    ${ContentInner} {
        ${media('>=desktop')} {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }

    ${Col}:first-child {
        ${media('>=desktop')} {
            align-self: stretch;
        }
    }
    ${Row} {
        ${media('>=desktop')} {
            padding-bottom: 121px;
        }
    }
`

const ImagesWrap = styled.div`
    box-sizing: border-box;
    position: relative;
    pointer-events: none;
    display: flex;
    ${media('<desktop')} {
        flex-direction: column;
        margin: 0 -30px;
    }
    ${media('>=desktop')} {
        justify-content: flex-end;
        align-items: flex-start;
    }

    .gatsby-image-wrapper {
        width: 70%;
        ${media('>=desktop')} {
            height: 400px;
            width: 308px;
            min-width: 308px;
            min-height: 400px;
        }
    }

    .Image1 {
        ${media('>=desktop')} {
            margin-right: -200px;
            margin-left: 200px;
        }
    }

    .Image2 {
        margin-top: 200px;
        ${media('<desktop')} {
            margin-top: -50%;
            align-self: flex-end;
        }
    }
`

const CollageContentBlock = ({ title, copy }) => (
    <ContentInner>
        <H2>{title}</H2>
        <BodyCopy
            dangerouslySetInnerHTML={{
                __html: copy.childMarkdownRemark.html,
            }}
        />
    </ContentInner>
)

const Collage = ({ data }: { data: object }) => {
    const { images, title, copy, layout } = data
    return (
        <CollageSection layout={layout}>
            <Container narrow={layout != '2' ? true : undefined}>
                <Row middle="md">
                    <Col md={6}>
                        {layout != '2' ? (
                            <ImagesWrap>
                                {images &&
                                    images.map((image, index) => {
                                        return (
                                            <Img
                                                fluid={image.fluid}
                                                key={index}
                                                className={`Image${index + 1}`}
                                                alt=""
                                            />
                                        )
                                    })}
                            </ImagesWrap>
                        ) : (
                            <Img fluid={images[0].fluid} alt="" className="Image1" />
                        )}
                    </Col>
                    <Col md={6}>
                        <Content>
                            <CollageContentBlock title={title} copy={copy} />
                            {layout == '2' && <Img fluid={images[1].fluid} alt="" className="Image2" />}
                        </Content>
                    </Col>
                </Row>
            </Container>
        </CollageSection>
    )
}

export default Collage
